<template>
  <div class="sdv-chart">
    <!-- {{ chartData }}
    {{ chartConfig }} -->
    <div ref="el" class="el" />
    <div v-if="hasExternalLegend" class="external-legend">
      <map-legend :config="chartConfig.ItemsHelper.colorScale.value" :all-time-values="allTimeValues" :data-card="dataCard" />
    </div>
    <div v-if="badData" class="overlay"><div class="text">{{ $t('no_data_for_these_filters') }}</div></div>
    <div v-if="tooMuchData" class="overlay"><div class="text">{{ $t('too_much_data') }}</div></div>
  </div>
</template>

<script>
import $ from 'jquery'
import chartUtils from '@/utils/chart'
import MapLegend from '@/components/maps/MapLegend.vue'
import * as sdv from '@/lib/sdv-lib'
import { langISODict } from '@/i18n'
import { maskValue } from '@/utils/formatUtils'
export default {
  components: { MapLegend },
  props: {
    pivotConfig: {
      type: Object,
    },
    chartConfig: {
      type: Object,
    },
    dimensionMetas: {
      type: Object,
    },
    data: {},
    dataCard: {},
    chartType: {
      type: String,
    },
    tooltipFunction: {
      type: Function,
    },
    options: {
      type: Object,
    },
    // colorScaleConfig: {
    //   type: Object,
    // },
    allTimeValues: {
      type: Array,
    },
    lite: {
      type: Boolean
    }
  },
  computed: {
    sdvComponent() {
      let tmp = chartUtils[this.chartType].sdvComponent
      return tmp
    },
    badData() {
      // PARA cuando hay algo como "españa" pero no tiene ningun dato... (creo que vale para todos los chartTypes)
      if (this.chartData.length === 1) return true
      if (chartUtils[this.chartType].checkBadData)
        return chartUtils[this.chartType].checkBadData(this.chartData)
      else return this.chartData && this.chartData.slice(1).every(d => !d[1])
    },
    tooMuchData(){
      return this.chartType === 'heat-map' && this.data.values.flat().length  - this.data.values.length>500
    },
    chartData() {
      let arr = []
      let toDate = v => {
        return this.sdvComponent === 'LineChart' ? v.timeValue : v.label || v
      }

      if (this.data) {
        arr[0] = this.data?.header[0].map(h => {
          return h.label
        })
        let colCount = this.data.header[0].filter(h => h.type === 'col').length
        this.fillIds(this.data?.values, colCount).forEach(row => {
          arr.push(
            row.map((cell, i) => {
              if (i === 0) return cell && toDate(cell)
              else return cell && (cell.label || cell)
            })
          )
        })
      }

      return arr
    },
    allIds() {
      let xDim = this.pivotConfig.dimensions.find(d => d.role === 'rows')
      if (!xDim) return []
      let ids = this.pivotConfig.dimensions
        .find(d => d.role === 'rows')
        .values.map(d => this.options[xDim.id].find(dd => dd.id === d.value))
      return ids
    },
    hasExternalLegend() {
      return this.chartType === 'heat-map' && this.chartConfig?.LegendBehavior?.showLegend.value
    },
  },
  watch: {
    sdvComponent: {
      handler() {
        this.instantiateChart()
      },
      // immediate: true,
    },
    chartData: {
      handler(value) {
        // Para justo cuando se instancia...
        if (
          this.instance &&
          this.sdvComponent === this.instance.constructor.name.replace('Component', '')
        ) {
          this.setChartData(value)
        }
      },
    },
    chartConfig: {
      handler(value) {
        let newConfig = value
        if (this.instance && newConfig) this.instance.config = newConfig
        this.instance.new = false
      },
      deep: true,
    },
  },
  mounted() {
    this.instantiateChart()
  },
  methods: {
    setChartData(value) {
      if (!this.badData && !this.tooMuchData && this.instance) {
        this.updateAxisTitles()
        this.instance.viz.chart.__allTimeValues = this.allTimeValues
        this.instance.data = { data: value }
      }
    },
    updateAxisTitles() {
      if (!this.instance.config.AxisHelper) return
      /// X  TITLE
      let xTitle
      let xDim = this.pivotConfig.dimensions.find(d => d.role === 'rows')
      if (
        this.dimensionMetas[xDim.id].type === 'time' ||
        this.dimensionMetas[xDim.id].type === 'location'
      )
        xTitle = this.pivotConfig.dimensions.find(d => d.id === xDim.id + '_type').values[0].value
      else xTitle = this.dimensionMetas[xDim.id].label
      /// Y TITLE
      let yTitle =
        this.dataCard.data[0].measureUnit +
        (this.dataCard.data[0].symbolUnit ? ' (' + this.dataCard.data[0].symbolUnit + ')' : '')


      //RARUNO ESTO...
      if (this.sdvComponent === 'ConnectedDotPlot') {
        let tmp = xTitle
        xTitle = yTitle
        yTitle = tmp
      }

      
      if(this.sdvComponent === 'HeatMap'){
        let yDim = this.pivotConfig.dimensions.find(d => d.role === 'columns')
        yTitle = yDim && this.dimensionMetas[yDim.id].label
      }
      
      
      this.instance.config.AxisHelper.x.title = xTitle
      this.instance.config.AxisHelper.y.title = yTitle

      if (this.sdvComponent === 'PyramidChart') {
        let genderMeta = Object.values(this.dimensionMetas).find(d => d.type === 'gender')
        let genderDim = genderMeta && this.pivotConfig.dimensions.find(d => d.id === genderMeta.id)
        let ageDim = Object.values(this.dimensionMetas).find(d => d.type === 'age')

        if (genderDim) {
          console.log('genderDim', genderDim)
          this.instance.config.AxisHelper.y.title = genderDim.values.map(v => this.allIds.find((vv)=>vv.id===v.value).label)
          this.instance.config.AxisHelper.x.title = ageDim.label
        }
        this.instance.config.AxisHelper.xDimTitle = yTitle
      }
      if(this.lite){
        this.instance.config.lite = true
        this.instance.config.AxisHelper.x.title = null
        if (this.sdvComponent !== 'PyramidChart'){
          this.instance.config.AxisHelper.y.title = null
        }
        if(this.instance.config.AxisHelper.xDimTitle) this.instance.config.AxisHelper.xDimTitle = null
      }
    },
    instantiateChart() {
      if (!this.sdvComponent) return
      let $el = this.$refs.el
      $($el).empty()
      let component = sdv[this.sdvComponent]
      //CUSTOM CONFIGS,
      let customConfig
      try {
        customConfig = JSON.parse(
          JSON.stringify(sdv.configUtils.extractValues(this.chartConfig || {}))
        )
      } catch {
        customConfig = JSON.parse(JSON.stringify(this.chartConfig || {}))
      }
      if (!customConfig.title) customConfig.title = { value: '' }
      customConfig.locale = { value: langISODict[this.$store.state.i18n.lang] }
      customConfig.valueFormat = value => maskValue(value, this.dataCard)
      
      if (this.dataCard.mask?.indexOf('%') >= 0) {
        if (this.sdvComponent === 'ConnectedDotPlot') {
          customConfig.AxisHelper = { x: { valueFormat: { value: '[N].0%' } } }
        } else if (
          component.defaultConfig.AxisHelper ||
          component.vizClass.defaultConfig.AxisHelper
        ) {
          customConfig.AxisHelper = { y: { valueFormat: { value: '[N].0%' } } }
        }
      }
      // porque solo hay una, que sino hay que hacerlo mejor en sus "utils"
      if (this.sdvComponent === 'BarChart') {
        let xDim = this.pivotConfig.dimensions.find(d => d.role === 'rows')
        if (this.dimensionMetas[xDim.id].type === 'time') {
          //AQUI SE ESTA PERDIENDO INFO DE LA BASE LIB FIX TITLE BAR-CHART
          customConfig.ItemsHelper = { colorScale: { value: 'single' } }
        }
      }
      //los "injected" lo necesitan ANTES del instantiate pero los "PivotComponent" despues....
      if (this.tooltipFunction)
        customConfig.TooltipBehavior = { getHtml: { value: this.tooltipFunction } }
      let instance = new component($el, null, customConfig)
      // let instance = new component($el, { data: this.chartData }, {})
      instance.onReady = () => {
        this.instance = instance
        // console.log('chart was drawn and can be modified')
        if (this.chartData) {
          this.setChartData(this.chartData)
        }

        let defaults = this.instance._getConfig()
        let values = this.instance.viz.chart._config
        let nonDefaults = sdv.configUtils.filterNonDefaults(values, defaults)

        let merged = sdv.configUtils.mergeConfig(nonDefaults, defaults)
        merged = sdv.configUtils.setDefaultValues(merged)
        // los "injected" lo necesitan ANTES del instantiate pero los "PivotComponent" despues....
        if (this.tooltipFunction) merged.TooltipBehavior.getHtml.value = this.tooltipFunction
        console.log('DEFAULT CONFIG', merged)
        // merged.ItemsHelper.colorScale.value = 'single'
        instance.new = true
        this.$emit('change-chart-config', merged)
      }
    },
    getNonDefaultConfig() {
      let defaults = this.instance._getConfig()
      let values = this.instance.viz.chart._config
      let nonDefaults = sdv.configUtils.filterNonDefaults(values, defaults)
      return nonDefaults
    },
    fillIds(data, colCount) {
      colCount
      // LO DESACIVAMOS "porque lo piden"...
      // if (this.sdvComponent === 'BarChart') {
      //   data = [
      //     ...this.allIds.map(idOb => {
      //       return data.find(d => d[0].value === idOb.id) || [idOb.label, 0]
      //     }),
      //   ]
      // } else if (this.sdvComponent === 'StackedBars' || this.sdvComponent === 'GroupedBars') {
      //   data = [
      //     ...this.allIds.map(idOb => {
      //       return (
      //         data.find(d => d[0].value === idOb.id) || [idOb.label, ...new Array(colCount).fill(0)]
      //       )
      //     }),
      //   ]
      // }
      return data
    },
  },
}
</script>

<style lang="stylus" scoped>
.sdv-chart
  height: 100%
  
  >>> .chart-container
    overflow: visible

  // border: solid 2px #f90
  .el
    width: 100%
    height: 100%
    border: none !important

  .overlay
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(255, 255, 255, 0.8)

    .text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      text-align center

  .map-legend
    position: absolute
    top: vw(0)
    left: vw(40)
    z-index: 2
</style>
